import React, { useState } from 'react'
import Stack from '@mui/material/Stack'
import Paper from '@mui/material/Paper'
import Button from '@mui/material/Button'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import ReplyIcon from '@mui/icons-material/Reply'
import { Box, Grid } from '@mui/material'
import Link from '@mui/material/Link'
import API from '../../../services/API'
import validator from 'validator'
import BigModal from '../../../components/Modals/BigModal'
import AcceptApplication from './AcceptApplication'
import RejectApplication from './RejectApplication'
import ExtendOffer from './ExtendOffer'

export const ActionPanelItem = ({ children, fullWidth }) => (
  <Grid item xs={12} lg={fullWidth ? 12 : 6}>
    {children}
  </Grid>
)

const ActionPanel = ({
  actionPanelRef,
  setSelectedApplication,
  application,
  getApplication,
}) => {
  return (
    <Box
      component={Paper}
      padding={1}
      display="flex"
      justifyContent="center"
      alignItems="center"
      ref={actionPanelRef}
    >
      <Grid container spacing={1} alignItems="center">
        <ActionPanelItem fullWidth>
          {application?.userAccount?.email && (
            <Link
              href={`mailto:${application.userAccount.email}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button variant="outlined" color="primary" fullWidth size="small">
                Email Applicant
              </Button>
            </Link>
          )}
        </ActionPanelItem>
        <ExtendOffer application={application} getApplication={getApplication} />
        <AcceptApplication applicationID={application._id} disabled={application.state !== 'Submitted'}/>
        <RejectApplication applicationID={application._id} disabled={!['Draft', 'Submitted'].includes(application.state)}/>
      </Grid>
    </Box>
  )
}

export default ActionPanel
